import { render, staticRenderFns } from "./OtpVerify.vue?vue&type=template&id=61ec2d3f&scoped=true"
import script from "./OtpVerify.vue?vue&type=script&lang=js"
export * from "./OtpVerify.vue?vue&type=script&lang=js"
import style0 from "./OtpVerify.vue?vue&type=style&index=0&id=61ec2d3f&prod&lang=scss"
import style1 from "./OtpVerify.vue?vue&type=style&index=1&id=61ec2d3f&prod&scoped=true&lang=css"
import style2 from "./OtpVerify.vue?vue&type=style&index=2&id=61ec2d3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ec2d3f",
  null
  
)

export default component.exports